"use strict";
var carbucks = carbucks || {};
const sitenavigationOpen = document.getElementById("js-site-navigation-open");
const siteNavigation = document.getElementById("js-site-navigation");
carbucks.siteNavigation =
  carbucks.siteNavigation ||
  (function() {
    function init() {
      if (open) {
        sitenavigationOpen.addEventListener("click", function() {
          siteNavigation.classList.toggle("site-navigation--open");
          sitenavigationOpen.classList.toggle("site-navigation-open--open");
          document.body.classList.toggle("no-scroll");
          document.body.classList.toggle("site-nav-is-open");
        });
      }
    }
    return {
      init: init,
    };
  })();
